"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { System } from "Constants/objects";
import FormEditTable from "Components/Forms/FormEditTable";
import { createTableComponentID } from "D5Utils/functions";

var D5FormLayoutSubforms =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5FormLayoutSubforms, _PureComponent);

  function D5FormLayoutSubforms() {
    _classCallCheck(this, D5FormLayoutSubforms);

    return _possibleConstructorReturn(this, _getPrototypeOf(D5FormLayoutSubforms).apply(this, arguments));
  }

  _createClass(D5FormLayoutSubforms, [{
    key: "getLSName",
    value: function getLSName(formID, parentFormID, formType) {
      return createTableComponentID(formID, parentFormID, formType);
    }
  }, {
    key: "render",
    value: function render() {
      // todo:
      var options = this.props.options;
      var formID = options.formID,
          parentFormID = options.parentFormID,
          formType = options.formType;
      return React.createElement(FormEditTable, {
        formID: formID,
        parentFormID: parentFormID,
        formType: formType,
        filtersData: options.filtersData,
        formTableMode: options.parentFormID != null,
        UUID: "FormEditTable-".concat(this.getLSName(formID, parentFormID, formType)),
        isFocus: options.isFocus,
        viewSource: options.viewSource,
        requestColumns: options.requestColumns,
        formFilters: options.formFilters,
        viewMode: System.FORM_TYPE.LIST,
        relationType: options.relationType,
        key: "D5FormLayoutContainerTableItem-".concat(options.formID)
      });
    }
  }]);

  return D5FormLayoutSubforms;
}(PureComponent);

_defineProperty(D5FormLayoutSubforms, "propTypes", {
  options: PropTypes.object.isRequired
});

export { D5FormLayoutSubforms as default };
;